<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">SyncHPC CLI</h4>
  <button (click)="cancel()">
    <i style="z-index: 1" class="bi bi-x-lg text-danger" title="Open SyncHPC CLI" color="warn" title="Close"></i>
  </button>
</div>
<div class="modal-body" style="padding:24px">
  <form
    [formGroup]="terminalLogin"
    name="terminalLogin"
    autocomplete="off"
    spellcheck="false"
  >
    <p>Enter Credentials.</p>
    <p>
      <mat-form-field  class="w-100">
        <mat-label>Username</mat-label>
        <input
          type="text"
          matInput
          placeholder="Username"
          formControlName="username"
        />
        <mat-error
          *ngIf="
            terminalLogin.get('username').touched &&
            terminalLogin.get('username').invalid
          "
          >Username Required.</mat-error
        >
      </mat-form-field>
    </p>

    <p>
      <mat-form-field  class="w-100">
        <mat-label>Password</mat-label>
        <input 
          [type]="!fieldTextType ? 'text' : 'password'"
          matInput
          placeholder="Password"
          formControlName="password"
        />
        <mat-icon
          *ngIf="terminalLogin.get('password').value && terminalLogin.get('password').value !== ''"
          (click)="togglePasswordIcon()"
          matSuffix
          class="bi classPassIcon"
          [ngClass]="{
            'bi-eye-fill': fieldTextType,
            'bi-eye-slash-fill': !fieldTextType
          }"
        ></mat-icon>
        <mat-error
          *ngIf="
            terminalLogin.get('password').touched &&
            terminalLogin.get('password').invalid
          "
          >Password Required.</mat-error
        >
      </mat-form-field>
    </p>
  </form>
  <div *ngIf="!utilityType"><p>Note : If you face any issue in terminal, please click <a style="z-index: 2; color: blue; text-decoration: underline; cursor: pointer;" (click)="redirectToVmIP()">here</a> to authenticate terminal service from browser.</p></div>
</div>
<div class="modal-footer">
  <ng-container *ngIf="isUtilityServiceActive">
    <button (click)="submit()" type="submit" class="btn btn-primary w-100">
      Connect
    </button>
  </ng-container>
  <ng-container *ngIf="!isUtilityServiceActive">
    <button [disabled]="isFetchingStatus" (click)="checkServiceStatus()" type="submit" class="btn btn-primary w-100">
      {{ isFetchingStatus ? "Checking" : "Check" }} Connection
    </button>
  </ng-container>
</div>
